// extracted by mini-css-extract-plugin
export default {"button":"AppleCalendarButton_button__GbHTG","icon":"AppleCalendarButton_icon__0aOsH"};